import { AutoGraph, CloudDoneOutlined, NotificationsOutlined } from '@mui/icons-material';
import {
  InventoryOutlinedIcon,
  DataTableIcon,
  BeerSubscriptionIcon,
  GraphAltIcon,
  Tap2Icon,
  FridgeWhiteIcon,
} from 'assets/icons';

const text = {
  smartMonitoringCooling: {
    subscription: {
      description: {
        default: 'SystemConfiguration.smartMonitoringCoolingSubscriptionDefault',
        active: 'SystemConfiguration.smartMonitoringCoolingSubscriptionActive',
      },
    },
    details: {
      description: 'SystemConfiguration.smartMonitoringCoolingDetails',
    },
  },

  smartDraft: {
    subscription: {
      description: {
        default: 'SystemConfiguration.smartDraftSubscriptionDefault',
        active: 'SystemConfiguration.smartDraftSubscriptionActive',
      },
    },
    details: {
      description: 'SystemConfiguration.smartDraftDetails',
    },
  },
};

const details = {
  smartMonitoringCooling: {
    image: '/assets/images/smart_monitoring_image.png',
    subtitle: 'SystemConfiguration.smartMonitoringCoolingSubtitle',
    icon: <FridgeWhiteIcon className="icon" />,
    description: 'SystemConfiguration.smartMonitoringCoolingDescription',
    features: [
      {
        icon: <GraphAltIcon className="feature_icon" />,
        title: 'SystemConfiguration.smartMonitoringFeaturesTitle1',
        description: 'SystemConfiguration.smartMonitoringFeaturesDescription1',
      },
      {
        icon: <DataTableIcon className="feature_icon" />,
        title: 'SystemConfiguration.smartMonitoringFeaturesTitle2',
        description: 'SystemConfiguration.smartMonitoringFeaturesDescription2',
      },
      {
        icon: <CloudDoneOutlined className="feature_icon" />,
        title: 'SystemConfiguration.smartMonitoringFeaturesTitle3',
        description: 'SystemConfiguration.smartMonitoringFeaturesDescription3',
      },
      {
        icon: <NotificationsOutlined className="feature_icon" />,
        title: 'SystemConfiguration.smartMonitoringFeaturesTitle4',
        description: 'SystemConfiguration.smartMonitoringFeaturesDescription4',
      },
    ],
  },
  smartDraft: {
    subtitle: 'SystemConfiguration.smartDraftSubtitle',
    icon: <Tap2Icon className="icon" />,
    description: 'SystemConfiguration.smartDraftDescription',
    image: '/assets/images/smart_draft_image.png',
    features: [
      {
        icon: <BeerSubscriptionIcon className="feature_icon" />,
        title: 'SystemConfiguration.smartDraftFeaturesTitle1',
        description: 'SystemConfiguration.smartDraftFeaturesDescription1',
      },
      {
        icon: <DataTableIcon className="feature_icon" />,
        title: 'SystemConfiguration.smartDraftFeaturesTitle2',
        description: 'SystemConfiguration.smartDraftFeaturesDescription2',
      },
      {
        icon: <InventoryOutlinedIcon className="feature_icon" />,
        title: 'SystemConfiguration.smartDraftFeaturesTitle3',
        description: 'SystemConfiguration.smartDraftFeaturesDescription3',
      },
      {
        icon: <AutoGraph className="feature_icon" />,
        title: 'SystemConfiguration.smartDraftFeaturesTitle4',
        description: 'SystemConfiguration.smartDraftFeaturesDescription4',
      },
    ],
  },
};

export { text, details };
